import { useMutation, useQuery } from "@apollo/client/react";import React, { useState, useMemo } from "react";

import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
// import UPDATE_HONORARIOS_PROFESIONAL from "../../../../../data/graphQL/mutations/GestionAsistencial/updateHonorarioProfesional";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { Grid } from "@mui/material";
import toast from 'react-hot-toast';
import { CREATE_PROFESIONAL_MONITOREO_SUGERENCIA } from "../../../../../data/graphQL/mutations/Profesionales/createProfesionalMonitoreoSugerencia";
import { GET_CALIFICACION_MONITOREO } from "../../../../../data/graphQL/queries/GestionAsistencial/getCalificacionMonitoreo";

export function ClasificacionMonitoreoDialog({
  open,
  handleCloseDialog,
  monitoreoSelected,
  fetchProfesionalMonitoreos
}) {
  const [loading, setLoading] = useState(false);
  const [clasificacion, setClasificacion] = useState([]);
  const handleChange = (name, value) => {
    setClasificacion((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };


  const [createProfesionalMonitoreoSugerencia] = useMutation(CREATE_PROFESIONAL_MONITOREO_SUGERENCIA);
  const { data: dataCalificacionMonitoreo } = useQuery(
    GET_CALIFICACION_MONITOREO
  );

  const adaptMonitoreoSugerenciaToServiceInput = (clasificacion, idProfesionalMonitoreo, idClasificacionAnterior) => {
    return {
      idProfesionalMonitoreo: idProfesionalMonitoreo,
      idClasificacionSugerencia: clasificacion.idClasificacionSugerencia,
      observacion: clasificacion.observacion,
      idClasificacionAnterior: idClasificacionAnterior
    };
  };

  const handleAcceptUpdate = async () => {
    try {
      setLoading(true);


      const input = adaptMonitoreoSugerenciaToServiceInput(
        clasificacion,
        monitoreoSelected.idProfesionalMonitoreo,
        monitoreoSelected.idClaseMonitoreo
      );

      const { data } = await createProfesionalMonitoreoSugerencia({
        variables: { input }
      });

      if (data?.createProfesionalMonitoreoSugerencia) {
        toast.success("Sugerencia de monitoreo creada con éxito.");
        handleCloseDialog();
      } else {
        toast.error("No se pudo crear la sugerencia. Intente nuevamente.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Ocurrió un error al crear la sugerencia.");
    } finally {
      setLoading(false);
      fetchProfesionalMonitoreos();
    }
  };

  const updatedFields = useMemo(() => {
    return structuredClone(fields).
    map((input) => {
      const updatedInput = { ...input };
      switch (input.name) {
        case 'idClasificacionSugerencia':
          updatedInput.options = dataCalificacionMonitoreo?.claseMonitoreo?.map((claseMonitoreo) => ({ id: claseMonitoreo.idClaseMonitoreo, displayName: claseMonitoreo.descripcion }));
          break;
      }
      return updatedInput;
    });
  }, [
  clasificacion,
  dataCalificacionMonitoreo]
  );

  return (
    <CustomDialog
      title="Agregar Monitoreo"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      onAccept={handleAcceptUpdate}
      cancelText="Cancelar"
      acceptText="Agregar clasificacion"
      acceptLoading={loading}
      acceptDisabled={loading}>
      
      <Grid container spacing={3}>
        {updatedFields.map((input, index) =>
        <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== "item" ? 12 : 0 }}>
            {
          <RenderInputByTypeMobile
            key={`input-${input.name}-index-${index}`}
            input={input}
            handleChange={handleChange}
            value={clasificacion[input.name]} />

          }
          </Grid>
        )}
      </Grid>
    </CustomDialog>);

}

const fields = [
{
  displayName: 'Clasificacion',
  name: 'idClasificacionSugerencia',
  type: 'select',
  disabled: false,
  col: 6
},
{
  displayName: 'Observacion',
  name: 'observacion',
  type: 'long_string',
  disabled: false,
  col: 12
}];